import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import type { MetricValues } from '@/modules/finances/types';
import { SemiAnnualCell } from './cell-semi-annually';
interface SemiAnnualHeaderProps {
  title: string;
  className?: string;
  headerTable: MetricValues[];
  activeMetrics: string[];
  year: string;
}
export const defaultOrder = ['Budget', 'Forecast', 'Net Protocol Outflow', 'Net Expenses On-Chain', 'Actuals'];
export const orderMetrics = (metricOrder = defaultOrder, metricsToOrder: string[]) => {
  const orderedMetrics: string[] = [];
  metricOrder.forEach(metric => {
    if (metricsToOrder.includes(metric)) {
      orderedMetrics.push(metric);
    }
  });
  return orderedMetrics;
};
export const getKeyMetric = (metric: string) => {
  if (metric === 'Net Expenses On-Chain') {
    return 'PaymentsOnChain';
  }
  if (metric === 'Net Expenses Off-chain') {
    return 'PaymentsOffChainIncluded';
  }
  if (metric === 'Net Protocol Outflow') {
    return 'ProtocolNetOutflow';
  }
  return metric;
};
export const filterActiveMetrics = (activeMetrics: string[], headerTable: MetricValues[]) => headerTable.map(header => {
  const filteredMetrics: Partial<MetricValues> = {};
  activeMetrics.forEach(metric => {
    const matchKey = getKeyMetric(metric);
    if (matchKey in header) {
      filteredMetrics[matchKey as keyof MetricValues] = header[matchKey as keyof MetricValues];
    }
  });
  return filteredMetrics;
});
function SemiAnnualHeader(t0) {
  const $ = _c(22);
  const {
    title,
    className,
    headerTable,
    activeMetrics,
    year
  } = t0;
  let t1;
  if ($[0] !== year) {
    t1 = year.substring(2, 4);
    $[0] = year;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `H1'${t1}`;
  let t3;
  if ($[2] !== year) {
    t3 = year.substring(2, 4);
    $[2] = year;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `H2'${t3}`;
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = [t2, t4, "Total"];
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const keysMetrics = t5;
  let t6;
  if ($[7] !== activeMetrics || $[8] !== headerTable) {
    t6 = filterActiveMetrics(activeMetrics, headerTable);
    $[7] = activeMetrics;
    $[8] = headerTable;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const metricsActive = t6;
  let t7;
  if ($[10] !== className) {
    t7 = cn("", className);
    $[10] = className;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== title) {
    t8 = <div className="flex h-12 w-21.25 items-center justify-start truncate border-r py-4 pl-2"><div className="max-w-full text-xs font-bold wrap-break-word whitespace-break-spaces md:text-base xl:whitespace-normal">{title}</div></div>;
    $[12] = title;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== activeMetrics || $[15] !== keysMetrics || $[16] !== metricsActive) {
    t9 = <div className="flex flex-1 items-center [&>div:last-of-type]:min-h-21">{keysMetrics.map((period, index) => <SemiAnnualCell key={index} metrics={metricsActive[index]} semiannual={period} activeMetrics={orderMetrics(undefined, activeMetrics)} isTotal={period === "Total"} />)}</div>;
    $[14] = activeMetrics;
    $[15] = keysMetrics;
    $[16] = metricsActive;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t8 || $[20] !== t9) {
    t10 = <div className={t7}>{t8}{t9}</div>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}
export { SemiAnnualHeader };